import { Container } from './container';
import { ContainerService } from './container.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ContainerResolver {
  constructor(private containerService: ContainerService) {}

  resolve(): Observable<Container[] | null> {
    return this.containerService.getContainers();
  }
}
